import Page from "./page";

export default class News extends Page {}
